const newsletter = `
# eBL Newsletter 3

## 7 April 2021

### Fragmentarium

#### New URL

- We have set up the official domains for the eBL application:
  - [https://www.ebl.lmu.de/](https://www.ebl.lmu.de/)
  - [https://www.ebl.uni-muenchen.de/](https://www.ebl.uni-muenchen.de/)
- Please, start using the above URLs. ebabylon.org will be changed to redirect
  to an official domain and will be removed in the future.

#### ORACC ATF Import and C-ATF Import

- It is now possible to import files in C-ATF and files in ORACC-ATF with
  Lemmatisation into the Fragmentarium. Please let us know if you have any
  legacy ATF file you would like to upload.

#### New Display of the Dictionary

- Clicking on the lemma in the eBL-CDA dictionary will now bring you to a newly
  structured view of the dictionary entry. This view will be extended with
  additional lexicographical resources in the future.

#### Conventions

- The syntax for the indication of parallels in the Fragmentarium has been
  extended. Pointing to other fragments in the Fragmentarium is now possible
  according to the // F schema already in use in the Corpus. See
  [Corpus Conventions 2.7.4 Parallel Lines](<https://github.com/ElectronicBabylonianLiterature/generic-documentation/wiki/Editorial-conventions-(Corpus)#274-parallel-lines>).

### Corpus

#### Corpus Conventions

- Colophons are to be edited in the respective field in the List of Manuscripts.
  The transliteration should follow the eBL-ATF standard as it applies to
  editions of Fragments in the Fragmentarium. Note that the use of labels like
  e.g. o for obverse is not allowed. Use @-lines instead. See
  [Corpus Conventions 2.2.4 Edit Colophons](<https://github.com/ElectronicBabylonianLiterature/generic-documentation/wiki/Editorial-conventions-(Corpus)#224-edit-colophons>).
- Smaller additions were made under
  - 2.5.4 Special Cases (normalize _igīgū_ instead of _igigû_)
`

export default newsletter
